// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact"}[chunkId] + "." + {"443":"5a460c7c","631":"0863b0dd"}[chunkId] + ".css";
};